import React from 'react';
import resumeData from '../data/resumeData.json';

const Profiles = ({ data = resumeData.profiles }) => {
  return (
    <section className="o-section t-section">
      <div className="o-section__header-bg t-section__header"></div>
      <div className="o-section__content-bg t-section__content"></div>

      <div className="o-container">
        <div className="o-section__container">
          <header className="o-section__header t-section__header">
            <div className="o-content">
              <h2 className="o-section__heading">{data.heading}</h2>
              <div className="o-content__body o-section__description">{data.description}</div>
            </div>
          </header>

          <div className="o-section__content t-section__content">
            <div className="o-grid">
              {(data.items || []).map((profile) => (
                <div className="o-grid__col-xl-4 o-grid__col-sm-6" key={profile.id}>
                  <div className="o-content">
                    <a href={profile.href} target="_blank" rel="noopener noreferrer" className="t-link-container">
                      <div className="o-media o-media--block">
                        <div className="o-media__figure">
                          <div className="c-profile__icon">
                            <i className={profile.iconClass}></i>
                          </div>
                        </div>
                        <div className="o-media__body o-content__body">
                          <h3 className="t-link-container__item">{profile.title}</h3>
                          <p>{profile.text}</p>
                        </div>
                      </div>
                    </a>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Profiles;
